/**
 * @file: Employee.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 在岗人员信息
 */
import request from '@/utils/request'

/**
 * 多条件获取人员情况（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function employeeComplexOnpostListGet(data) {
  return request({
    type: 'biz',
    url: 'employee/complex/onpost/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂编号获取在岗人员信息(有打卡)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function employeeDeptOnpostListGet(data) {
  return request({
    type: 'biz',
    url: 'employee/dept/onpost/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂ID、承包商ID获取在岗人员统计类信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function employeeOnpostDcStatisticsGet(data) {
  return request({
    type: 'biz',
    url: 'employee/onpost/dc/statistics/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂编号、承包商ID获取在岗人员
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function employeeOnpostDeptcontraListGet(data) {
  return request({
    type: 'biz',
    url: 'employee/onpost/deptcontra/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取在岗人员个人信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function employeeOnpostInfoGet(data) {
  return request({
    type: 'biz',
    url: 'employee/onpost/info/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂编号获取所有人员
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function employeeOnpostListGet(data) {
  return request({
    type: 'biz',
    url: 'employee/onpost/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂编号获取在岗人员统计类信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function employeeOnpostStatisticsGet(data) {
  return request({
    type: 'biz',
    url: 'employee/onpost/statistics/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂编号分页获取在岗人员信息（废弃）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcEmployeeOnpostListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/employee/onpost/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Employee.js